const translateToReactSelect = (arrayValue, reverse) => {
  let after = [];
  if (reverse) {
    // react select to api
    for (let index = 0; index < arrayValue.length; index++) {
      let obj = {};
      obj.title = arrayValue[index].label;
      obj.id = arrayValue[index].value;
      after.push(obj);
    }
  } else {
    // api to react select
    for (let index = 0; index < arrayValue.length; index++) {
      let obj = {};
      obj.label = arrayValue[index].title;
      obj.value = arrayValue[index].id;
      after.push(obj);
    }
  }

  return after;
};
const compareDailyInfo = (data, type) => {
  let lastDay = 0,
    selectedDays = [];
  loop1: for (let index = 1; index < data.length; index++) {
    loop2: for (let index2 = 0; index2 < data[index].length; index2++) {
      loop3: for (const key in data[index][index2]) {
        if (key != "id" && key != "title" && data[index][index2][key]) {
          if (
            (key == "isPublic" && !data[index][index2][key]) ||
            (key == "noe" && !!data[index][index2][key][0].title) ||
            (key != "isPublic" && key != "noe")
          ) {
            lastDay = index;
            break loop2;
          }
        }
      }
    }
  }
  if (type == "get") {
    return lastDay;
  } else if (type == "set") {
    for (let index = 0; index < lastDay; index++) {
      selectedDays.push(data[index]);
    }
    return selectedDays;
  }
};
const unixToPersianDate = (TimeStamp) => {
  let options = { year: "numeric", month: "numeric", day: "numeric" };
  let date = new Date(parseInt(TimeStamp) * 1000).toLocaleDateString(
    "fa-IR",
    options
  );
  date.replace(/([۰-۹])/g, (token) =>
    String.fromCharCode(token.charCodeAt(0) - 1728)
  );
  return date;
};
const maskNumber = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export {
  translateToReactSelect,
  compareDailyInfo,
  unixToPersianDate,
  maskNumber,
};
